import * as Types from './types'

export const dropdownOption = (value: any, options: Types.DropdownOption[]): Types.DropdownOption => {
  return options.find((o: Types.DropdownOption) => o.value === value)
}
